import { FilterInput, SortInput, SupportedSortBy } from '@apeiron/common'
import { OrbitalTrackFilterInput, OrbitalTrackSortBy } from '@apeiron/orbital'
import { useAccountContext } from '@apeiron/temp'
import CostFilter from '@src/components/orbitalTrack/list/filter/CostFilter'
import TypeAndEffectFilter from '@src/components/orbitalTrack/list/filter/TypeAndEffectFilter'
import SaveFilter from '@src/components/share/filter/saveFilter/SaveFilter'
import { FavoriteType } from '@src/constants/favoriteFilter'
import { FC, useCallback } from 'react'

const OrbitalTrackFilter: FC<Props> = props => {
  const { filterInput, sortInput, onFilterChange } = props

  const { isLoggedIn } = useAccountContext()

  const handleOnFilterByFavorite = useCallback(
    (filter: FilterInput, sort: SortInput<SupportedSortBy>) => {
      onFilterChange(
        filter as OrbitalTrackFilterInput,
        sort as SortInput<OrbitalTrackSortBy>
      )
    },
    [onFilterChange]
  )

  return (
    <>
      {isLoggedIn && (
        <SaveFilter
          filterInput={filterInput}
          sortInput={sortInput}
          type={FavoriteType.OrbitalTrack}
          onFilterByFavorite={handleOnFilterByFavorite}
        />
      )}
      <TypeAndEffectFilter
        filterInput={filterInput}
        onFilterChange={onFilterChange}
      />
      <CostFilter filterInput={filterInput} onFilterChange={onFilterChange} />
    </>
  )
}

type Props = {
  filterInput: OrbitalTrackFilterInput
  sortInput: SortInput<OrbitalTrackSortBy>
  onFilterChange: (
    input: OrbitalTrackFilterInput,
    sort?: SortInput<OrbitalTrackSortBy>
  ) => void
}

export default OrbitalTrackFilter
